import { getCoreRecentAgentConversationsSlice } from './get';

export const { requestGetCoreRecentAgentConversations, resetGetCoreRecentAgentConversations } =
	getCoreRecentAgentConversationsSlice.asyncActionCreators;
